import { COSMOS_URL, DEPLOY_ENV } from 'components/globals';

const camelToTitleCase = (str: string): string => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (char) => char.toUpperCase())
    .trim();
};

const EXCLUDE_TAGS = ['blog', 'guide'];
// nb tags may be alike 'homeBuyingTips'
export const getArticleCategory = (tags: string[]): string => {
  const categoryTag = tags?.find((tag) => !EXCLUDE_TAGS.includes(tag));
  if (!categoryTag) {
    return '';
  }
  return camelToTitleCase(categoryTag);
};

export const articleTopicEnvRoot =
  COSMOS_URL + '/articles' + (DEPLOY_ENV === 'production' ? '' : '-v2') + '/topic';
